import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { AddressAutocompleteV2Component } from './address-autocomplete-v2.component';

@NgModule({
  declarations: [AddressAutocompleteV2Component],
  imports: [CommonModule, FormsModule],
  exports: [AddressAutocompleteV2Component]
})
export class AddressAutocompleteV2Module {}
